"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PENDING = exports.FAILED = exports.DONE = void 0;
var PENDING = exports.PENDING = 'pending';
var DONE = exports.DONE = 'done';
var FAILED = exports.FAILED = 'failed';